<template>
  <div style="margin-top: 20px">
    <div style="padding: 0 10px">
      <div style="margin-bottom: 10px">
        <el-button class="primary_btn" @click="handleAdd">新增</el-button>
      </div>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column
          align="center"
          prop="certTypeOneLabel"
          label="证书类型"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.certTypeOneLabel }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="certTypeTwoLabel" label="证书" />
        <el-table-column align="center" prop="major" label="专业" />
        <el-table-column align="center" prop="certTime" label="发证时间" />
        <el-table-column align="center" prop="certCode" label="证书编号" />
        <el-table-column align="center" prop="title" label="职称" />
        <el-table-column align="center" prop="certPhoto" label="证书照片">
          <template slot-scope="scope">
            <el-image
              :src="scope.row.certPhoto"
              style="width: 100px; height: 100px"
              :preview-src-list="[scope.row.certPhoto]"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column align="center" fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row)" type="text" size="small"
              >编辑</el-button
            >
            <el-button
              @click="handleDel(scope.row)"
              type="text"
              size="small"
              style="color: #f56c6c"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <x-cropper ref="iscropper"></x-cropper>
    <span
      class="dialog-footer"
      style="margin: 20px; display: flex; justify-content: space-between"
    >
      <div>
        <el-button @click="$emit('prveStep')">上一步</el-button>
        <el-button class="primary_btn" @click="notNow"> 下一步 </el-button>
      </div>
      <el-button @click="notNow">跳过</el-button>
    </span>

    <!-- 添加证书 -->
    <el-dialog
      title="添加证书"
      :visible.sync="dialogVisible"
      class="dialog-container"
      :before-close="handleClose"
    >
      <el-form
        ref="ruleForm"
        :rules="rules"
        :model="ruleForm"
        label-width="100px"
      >
        <div style="display: flex; flex-wrap: wrap">
          <el-form-item label="证书类型" prop="certTypeId">
            <el-select
              v-model="ruleForm.certTypeId"
              @change="changeSelect"
              placeholder="请选择证书类型"
            >
              <el-option
                v-for="(item, index) in titleList"
                :key="index"
                :label="item.label"
                :value="index + 1"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证书" prop="certTypeTwo" v-if="selectOne">
            <el-select v-model="ruleForm.certTypeTwo" placeholder="证书">
              <el-option
                v-for="(item, index) in certList"
                :label="item.label"
                :key="index"
                :value="index"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="专业" prop="major" v-if="selectOne">
            <el-input v-model="ruleForm.major"></el-input>
          </el-form-item>
        </div>

        <div style="display: flex; flex-wrap: wrap">
          <el-form-item label="发证时间" prop="certTime" v-if="selectOne">
            <el-date-picker
              type="date"
              :editable="false"
              placeholder="选择时间"
              value-format="yyyy-MM-dd"
              v-model="ruleForm.certTime"
              style="width: 100%; width: 217px"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="证书编号" prop="certCode" v-if="selectOne">
            <el-input
              v-model="ruleForm.certCode"
              style="width: 217px"
            ></el-input>
          </el-form-item>
          <el-form-item label="职称" prop="title" v-if="selectOne">
            <el-input v-model="ruleForm.title" style="width: 217px"></el-input>
          </el-form-item>
        </div>

        <el-form-item label="证书照片" prop="certPhoto">
          <el-upload
            class="avatar-uploader"
            ref="upload"
            accept=".png,.jpg,.ipeg"
            :headers="uploadHeaders"
            :action="upLoadUrl"
            :data="uploadData"
            :show-file-list="false"
            :on-success="handleSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img
              v-if="imageUrl"
              :style="pcShow ? 'width: auto' : ''"
              :src="imageUrl"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"> </i>
            <!-- <div v-if="!selectOne" slot="tip" class="el-upload__tip">注：知名专家学者应为中国建筑业协会专家或国家知名专家</div> -->
          </el-upload>
        </el-form-item>
      </el-form>
      <div style="display: flex" v-show="pcShow">
        <label class="el-form-item__label" style="width: 100px"
          >证书裁剪
        </label>
        <el-button type="primary" @click="openCut">点击裁剪</el-button>
      </div>

      <template v-slot:footer>
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >保 存</el-button
        >
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  registerCert,
  deleteCert,
  getCertByMemberCodeList,
  editCert,
  addSingleCert,
} from "../../../api/moudles/user.js";
import { upLoadUrl, uploadHeaders, uploadData } from "@/utils/uploadConfig.js";

import xCropper from "./x-cropper.vue";
export default {
  components: {
    xCropper,
  },
  data() {
    return {
      upLoadUrl,
      uploadHeaders,
      uploadData,
      code: "",
      pcShow: true,
      selectOne: false,
      fileName: "",
      imageUrl: "",
      dialogVisible: false,
      ruleForm: {
        certTypeId: "",
        certTypeTwo: "",
        major: "",
        certTime: "",
        certCode: "",
        certPhoto: "",
      },
      newForm: {},
      titleList: [
        {
          label: "执业资格类",
        },
        {
          label: "职称类证书",
        },
        {
          label: "其他",
        },
      ],
      certList: [],
      certListOne: [
        {
          label: "一级注册建造师",
        },
        {
          label: "二级注册建造师",
        },
        {
          label: "注册建筑师",
        },
        {
          label: "注册监理工程师",
        },
        {
          label: "造价工程师",
        },
        {
          label: "注册环保工程师",
        },
        {
          label: "注册安全工程师",
        },
        {
          label: "注册结构工程师",
        },
        {
          label: "注册土木工程师",
        },
        {
          label: "注册岩土工程师",
        },
        {
          label: "注册港口与航道工程师",
        },
        {
          label: "注册水利水电工程师",
        },
        {
          label: "注册道路工程师",
        },
        {
          label: "注册电气工程师",
        },
        {
          label: "注册会计师",
        },
        {
          label: "注册经济师",
        },
      ],
      certListTwo: [
        {
          label: "初级职称",
        },
        {
          label: "中级职称",
        },
        {
          label: "副高级职称",
        },
        {
          label: "正高级职称",
        },
      ],
      certListThree: [
        {
          label: "其他",
        },
      ],
      rules: {
        certTypeId: [
          {
            required: true,
            message: "请选择证书类型",
            trigger: "change",
          },
        ],
        certTypeTwo: [
          {
            required: true,
            message: "请选择证书",
            trigger: "change",
          },
        ],
        major: [
          {
            required: true,
            message: "请输入专业",
            trigger: "blur",
          },
        ],
        certTime: [
          {
            type: "string",
            required: true,
            message: "请选择发证日期",
            trigger: "change",
          },
        ],
        certCode: [
          {
            required: true,
            message: "请输入证书编号",
            trigger: "blur",
          },
        ],
        certPhoto: [
          {
            required: true,
            message: "请上传证书照片",
            trigger: "blur",
          },
        ],
      },
      tableData: [],
    };
  },
  props: ["memberCode"],
  created() {
    if (window.screen.width < 760) {
      this.pcShow = false;
    } else {
      this.pcShow = true;
    }

    const stepCert = JSON.parse(localStorage.getItem("stepCert"));
    if (stepCert && stepCert.length) {
      this.selectOne = true;
      const localCert = stepCert[0];
      this.ruleForm.certTypeId = parseInt(localCert.certTypeId);
      if (parseInt(localCert.certTypeId) == 1) {
        this.certList = this.certListOne;
      } else if (parseInt(localCert.certTypeId) == 2) {
        this.certList = this.certListTwo;
      } else {
        this.certList = this.certListThree;
      }
      this.ruleForm.certTypeTwo = parseInt(localCert.certTypeTwo);
      this.ruleForm.certCode = localCert.certCode;
      this.ruleForm.major = localCert.major;
      this.ruleForm.certTime = localCert.certTime;
      this.ruleForm.certPhoto = localCert.certPhoto;
      this.imageUrl = localCert.certPhoto;
    }

    this.getCertList();
  },
  methods: {
    getCertList() {
      const stepMember = JSON.parse(localStorage.getItem("stepMember"));
      getCertByMemberCodeList({
        data: {
          memberCode: stepMember.memberCode,
        },
        success: (res) => {
          if (res.code == 0) {
            this.tableData = res.data;
          }
        },
      });
    },
    // 编辑
    handleEdit(row) {
      this.imageUrl = row.certPhoto;
      this.certList = [];
      this.changeSelect(Number(row.certTypeId));

      this.ruleForm = {
        ...row,
        certTypeId: Number(row.certTypeId),
        certTypeTwo: Number(row.certTypeTwo),
      };

      this.dialogVisible = true;
    },
    handleDel(row) {
      this.$confirm("此操作将删除该证书, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteCert({
          data: {
            memberCode: this.memberCode,
            code: row.code,
          },
          success: (res) => {
            if (res.code == 0) {
              this.$message.success("删除成功!");
              this.getCertList();
            } else {
              this.$message.error(res.msg);
            }
          },
        });
      });
    },
    notNow() {
      registerCert({
        data: {
          memberCode: this.memberCode,
        },
        success: (res) => {
          if (res.code == 0) {
            setTimeout(() => {
              this.$emit("addActive");
            }, 500);
          } else {
            this.$message.error(res.msg);
          }
        },
      });
    },
    handleAdd() {
      this.imageUrl = "";
      this.certList = [];
      this.selectOne = false;
      this.ruleForm = {};

      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.ruleForm.resetFields();
      });
    },
    handleClose() {
      this.dialogVisible = false;
    },
    // 文件上传
    handleSuccess(file) {
      // 本地服务器路径
      this.$message({
        message: "上传成功",
        type: "success",
      });
      this.imageUrl = file.data;
      this.ruleForm.certPhoto = file.data;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.ruleForm.certPhoto) {
            this.$message.error("请先上传证书照片!");
            return;
          }
          if (this.ruleForm.code) {
            this.updateCert();
          } else {
            this.registerCert();
          }
        } else {
          return false;
        }
      });
    },
    // 编辑证书信息
    updateCert() {
      editCert({
        data: {
          code: this.ruleForm.code,
          certTypeId: this.ruleForm.certTypeId,
          certTypeTwo: this.ruleForm.certTypeTwo,
          major: this.ruleForm.major,
          certPhoto: this.ruleForm.certPhoto,
          certTime: this.ruleForm.certTime,
          certCode: this.ruleForm.certCode,
          title: this.ruleForm.title,
        },
        success: (res) => {
          if (res.code == 200 || res.code == 0) {
            this.$message({
              message: res.data,
              type: "success",
            });
            this.getCertList();
            this.dialogVisible = false;
          } else {
            this.$message.error(res.msg);
          }
        },
      });
    },
    // 新增证书
    async registerCert() {
      await addSingleCert({
        data: {
          certTypeId: this.ruleForm.certTypeId,
          certTypeTwo: this.ruleForm.certTypeTwo,
          major: this.ruleForm.major,
          certPhoto: this.ruleForm.certPhoto,
          certTime: this.ruleForm.certTime,
          certCode: this.ruleForm.certCode,
          title: this.ruleForm.title,
          memberCode: this.memberCode,
        },
        success: (res) => {
          if (res.code == 200 || res.code == 0) {
            this.$message({
              message: res.data,
              type: "success",
            });
            this.getCertList();
            this.dialogVisible = false;
            // 给父组件发送信息，xiayibu
            // setTimeout(() => {
            //   this.$emit("addActive");
            // }, 1500);
          } else {
            this.$message.error(res.msg);
          }
        },
      });
    },
    openCut() {
      this.$refs.iscropper.showModal({
        img: this.imageUrl, // 裁剪图片的地址
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: "jpeg", // 裁剪生成图片的格式
        info: true, // 裁剪框的大小信息
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 375, // 默认生成截图框宽度
        autoCropHeight: 245, // 默认生成截图框高度
        fixedNumber: [1, 1.5], // 截图框的宽高比例
        fixedBox: false, // 固定截图框大小 不允许改变
        fixed: false, // 是否开启截图框宽高固定比例
        canMove: true, // 上传图片是否可以移动
        canMoveBox: true, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: false, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        full: true, // 是否输出原图比例的截图
        enlarge: "1", // 图片根据截图框输出比例倍数
        mode: "contain", // 图片默认渲染方式
        success: (res) => {
          // console.log("res", res);
          const blob = new Blob([res.img], { type: "image/jpeg" });
          const formData = new FormData();
          formData.append("file", blob, "cropped_image.jpg");
          fetch(this.upLoadUrl, {
            method: "POST",
            body: formData,
            headers: this.uploadHeaders,
          })
            .then((response) => response.json())
            .then((res) => {
              this.$message({
                message: "上传成功",
                type: "success",
              });
              this.imageUrl = res.data;
              this.ruleForm.certPhoto = res.data;
            })
            .catch((error) => {
              console.error("Error uploading image:", error);
            });
        },
      });
    },
    // 选择证书
    changeSelect(e) {
      if (e == 1) {
        this.selectOne = true;
        this.certList = this.certListOne;
      } else if (e == 2) {
        this.selectOne = true;
        this.certList = this.certListTwo;
      } else {
        this.selectOne = true;
        this.certList = this.certListThree;
      }
    },
    beforeAvatarUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 20;
      // if (!isJPG) {
      // 	this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error("上传证书图片大小不能超过 20MB!");
      }
      return isLt2M;
    },
  },
};
</script>

<style scoped>
>>> .el-dialog__footer {
  text-align: center;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 128px;
  height: 128px;
  line-height: 128px;
  text-align: center;
  border: 1px solid #dcdfe6;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.primary_btn {
  background-color: #c22c25;
  color: #fff;
}
:deep(.dialog-container .el-dialog) {
  width: 60%;
}
@media screen and (max-width: 760px) {
  :deep(.dialog-container .el-dialog) {
    width: 100vw;
  }
}
</style>
